import {ElementsIconProps} from '../components';

export function FavoriteIcon(props: ElementsIconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="favorite_24px">
        <path
          id="Color"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.3497 20.3072C12.5897 20.9972 11.4197 20.9972 10.6597 20.2972L10.5497 20.1972C5.29973 15.4472 1.86973 12.3372 1.99973 8.4572C2.05973 6.7572 2.92973 5.1272 4.33973 4.1672C6.97973 2.3672 10.2397 3.2072 11.9997 5.2672C13.7597 3.2072 17.0197 2.3572 19.6597 4.1672C21.0697 5.1272 21.9397 6.7572 21.9997 8.4572C22.1397 12.3372 18.6997 15.4472 13.4497 20.2172L13.3497 20.3072Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}
